import { Button } from '$partials/ui';
import { formatLinkBlockToUrl } from '$utilities/format';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').PanelBasicBlock}
 */

const PanelBasic = ({
    backgroundColor,
    buttons,
    richText,
    title
}) => {
    const bgColor = `bg-surface-panel-${backgroundColor}`;
    return (
        <section className={`${bgColor} col-wrapper-breakout rounded-lg flex-grow`}>
            <div className='col-padding pt-24 pb-16'>
                <h2 className='type-style-sans-h1 w-full md:w-7/12'>
                    {title}
                </h2>
                {richText && (
                    <div
                        className='rich-text type-style-sans-h3 mt-8 w-full sm:w-7/12 md:w-5/12'
                        dangerouslySetInnerHTML={{ __html: richText}} />
                )}
                {buttons?.length > 0 && (
                    <div className='mt-24 sm:mt-40 flex flex-wrap gap-x-8'>
                        {buttons.map((button, idx) => {
                            return (
                                <Button
                                    as='a'
                                    className={`${idx === 0 ? 'button-primary-xl' : 'button-outcome-xl'}${button.ctaCssClass ? ' ' + button.ctaCssClass : ''}`}
                                    href={formatLinkBlockToUrl(button.ctaLink)}
                                    key={button.id}>
                                    {button.ctaLabel}
                                </Button>
                            );
                        })}
                    </div>
                )}
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default PanelBasic;
